<main fxLayout="column" fxLayoutAlign="start center">
  <div>
    <button mat-stroked-button (click)="addInput('text', false)">Champ texte</button>
    <button mat-stroked-button (click)="addInput('check', false)">Case à cocher</button>
  </div>

  <form #form="ngForm" (ngSubmit)="submit(form.value)" fxLayout="column" fxLayoutAlign="start center">
    <div class="form-group" *ngFor="let item of formConfig; let i = index" [ngModelGroup]="i">
     
     
     
      <mat-card *ngIf="item.type == 'text'"  fxLayout="column" fxLayoutAlign="start center" >

        <p>Champ texte libre</p>

        <mat-form-field class="form-group" autocomplete="off">
   
            <input matInput placeholder="Nom du champ" type="text" matInput [(ngModel)]="item.label" name="text" >
          </mat-form-field>

      
          <mat-slide-toggle color="primary" type="checkbox" name="fieldRequired" [(ngModel)]="item.required">Champ obligatoire</mat-slide-toggle>
     

        <button mat-flat-button color="warn" type="button"  (click)="removeElement(item, i)" >Supprimer cet élément</button>

        </mat-card>







      <mat-card *ngIf="item.type == 'check'" fxLayout="column" fxLayoutAlign="start center"  >

        <p>Case à cocher</p>

        <mat-form-field class="form-group" autocomplete="off">
   
            <input matInput placeholder="Nom du champ" type="text" matInput [(ngModel)]="item.label" name="text" >
          </mat-form-field>

        <!-- <input type="text" name="text" [(ngModel)]="item.label"/> -->

        <!-- <input type="checkbox" name="fieldRequired" [(ngModel)]="item.required"/> -->
        <mat-slide-toggle color="primary" type="checkbox" name="fieldRequired" [(ngModel)]="item.required">Champ obligatoire</mat-slide-toggle>

        <button mat-flat-button color="warn" type="button" (click)="removeElement(item, i)" > Supprimer cet élément </button>
      </mat-card>


    </div>

    <input type="submit" value="Valider"/>
  </form>
</main>
